import * as actionTypes from './actionTypes';
import axios from 'axios';
import { logout } from './auth';
import errorValidation from "../../services/ErrorValidation";
import HttpAPICall from "../../services/HttpAPICall";
import TapApiUrls, { APP_BASE_URL_2, ORG_API_BASE_URL_2 } from '../../services/TapApiUrls';
import { iscAppDataLoading } from './isc';
import { iamAppDataLoading } from './asset';
import { reportListingDataFetch } from './dashboard';
import { configurationAppDataLoading } from './configuration';
import Cookies from 'js-cookie';
import { authApi, server2Api } from '../../services/api';
import TapHelper from '../../services/TapHelper';

export const requisionFormDataStart = () => {
    return {
        type                :   actionTypes.REQUISION_FORM_DATA_INIT
    };
};

export const requisionFormDataDone = (formData) => {
    return {
        type                :   actionTypes.REQUISION_FORM_DATA_LOAD,
        requisionFormData   :   formData
    };
};

export const appInitilizationStarting   = () => {
    return {
        type                :   actionTypes.APP_DATA_INIT
    };
};

export const appInitilizationDataLoad   = (user_info, group_info, acl_info) => {
    return {
        type                :   actionTypes.APP_DATA_SUCCESS,
        user_info           :   user_info,
        group_info          :   group_info,
        acl_info            :   acl_info
    };
};

export const appInitilizationError   = (msg) => {
    return {
        type                :   actionTypes.APP_DATA_FAIL,
        error_msg           :   msg
    };
};

export const fireBaseSystemConfigUpdate   = (data) => {
    return {
        type                        :   actionTypes.FIREBASE_APP_VERSION_UPDATE,
        firebase_app_version        :   data && data.version    ?   data.version : '',
        firebase_allowed_ip         :   data && data.allowed_ip ?   data.allowed_ip :   null,
        firebase_maintenance_mode   :   data && data.maintenance_mode ? data.maintenance_mode : 'N'
    };
};

export const fireBaseCloudMessageUpdate   = (token) => {
    return {
        type                        :   actionTypes.FIREBASE_FCM_TOKEN_UPDATE,
        firebase_fcm_token          :   token,
    };
};

export const userDataSuccess   = (user_info) => {
    return {
        type                :   actionTypes.USER_DATA_SUCCESS,
        user_info           :   user_info,
    };
};

export const userDataInit   = () => {
    return {
        type                :   actionTypes.USER_DATA_INIT
    };
};



export const applicationInitLoading         =   (access_token,reload = true)  =>  {
    return dispatch => {
        const headers       =   { 
            'Accept'            :   'application/json',
            'Content-Type'      :   'application/json',
            'Authorization'     :   'Bearer ' + access_token,
            'X-Device-Id'       :   TapHelper.decrypt(TapHelper.cookiesGet("device_id"))
        };

        if(reload == true){
            dispatch(appInitilizationStarting());
        }

        const api               =   axios.create({
            baseURL             :   ORG_API_BASE_URL_2,
            withCredentials     :   true, // needed if cookies are used
            headers             :   headers,
            params              :   {
                source              :   'web',
            }
        });

        Promise.all([
            api.get("/user"),
            api.get("/info"),
            api.get("/user_permission")
        ])
        .then((results) => {
            let user                =   results[0].data.data;
            let user_info           =   {
                mobile                  :   user.mobile,
                email                   :   user.email,
                image                   :   user.image,
                name                    :   user.full_name,
                id                      :   user.id,
                user_type               :   user.user_type,
                widget_keys             :   user.widget_keys,
            };
            let group               =   results[1].data.data;
            let group_info          =   {
                group_name              :   group.group_name,
                group_id                :   group.tap_master_id,
                image                   :   group.image,
                image_path              :   group.image_path,
                detail                  :   group.detail,
                activate_group_logo     :   group.activate_group_logo ? group.activate_group_logo : 'N'
            };
            
            let acl                 =   results[2].data;
            let acl_info            =   {
                // group_modules           :   ["group","iam","hrm","isc"],
                group_modules           :   acl.group_modules,
                group_sub_modules       :   acl.group_sub_modules,
                user_modules            :   acl.user_modules,
                // user_modules            :   ["group","iam","hrm","isc"],
                permissions             :   acl.permissions,
                // permissions             :   permissions(),
                user_sub_modules        :   acl.user_role_sub_modules
            };
            dispatch(iscAppDataLoading(user_info,group_info,acl_info,access_token));
            dispatch(iamAppDataLoading(user_info,group_info,acl_info,access_token));
            dispatch(configurationAppDataLoading(user_info,group_info,acl_info,access_token))
            dispatch(reportListingDataFetch(access_token));
           
        }).catch(function (err) {
            errorValidation.apiErrorHandle(err, 'Application not initialize successfully.', false);
            dispatch(logout(access_token));
            dispatch(appInitilizationError('An Error Occured'));
        });
       
    };
    
}

export const updateUserDetail         =   (access_token)  =>  {
    return dispatch => {
        HttpAPICall.withAthorization('GET', APP_BASE_URL_2 + '/org/user', access_token, {})
            .then((response) => {
               let respData = response.data;
               let user                =   respData.data;
               let user_info           =   {
                   mobile                  :   user.mobile,
                   email                   :   user.email,
                   image                   :   user.image,
                   name                    :   user.full_name,
                   id                      :   user.id,
                   user_type               :   user.user_type,
                   widget_keys             :   user.widget_keys,
               };
               
              dispatch(userDataSuccess(user_info));
            }).catch(function (err) {
                errorValidation.apiErrorHandle(err, 'Application not initialize successfully.', false);
                dispatch(logout(access_token));
                dispatch(appInitilizationError('An Error Occured'));
            });
    };
};